import Sidebar_vue_vue_type_script_setup_true_lang_default from "./Sidebar.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/components/sidebar/Sidebar.vue
var Sidebar_default = Sidebar_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { Sidebar_default as default };

//# sourceMappingURL=Sidebar.vue.js.map